/**
 * Generic Abstract Dialog for attachments
 */
hrd.dashlets.AbstractAttachmentDialog = hrd.AbstractHTMLFormPopup.extend({
	init: function(parentFormInstance, options) {
		var defaults = {
			impl: 'hrd.dashlets.AbstractAttachmentDialog',
			title: xlate('common.attachment.dialog.title'),
			dragMessage: xlate('common.attachment.dialog.dragZone'),
			property: undefined,
			attachmentProperty: undefined,
			multiple: false,
			closeWhenUploaded: true,
			width: '400',
			uploadMethod: 'uploadFile',
			deleteMethod: 'deleteFile',
			basicIcon: 'fas fa-paperclip',
			showAttachments: true,
			droppable: true,
			customizeAcceptables: false,
			customizeValidation: false,
			customizeFileObjectEnhancement: true,
			updateFormObject: true,
			updateFormExtraField: undefined, // need to update formData with the "id" fields in case of create
		};
		this._super($.extend({}, defaults, options));
		this.parentFormInstance = parentFormInstance; // needed for auto fill image on close
	},
	getJSONProvider: function() {
		if (this.JSON_PROVIDER === undefined) {
			console.error('WARNING: a JSON_PROVIDER property MUST be given otherwise reimplement the "getJSONProvider" method');
		}
		return this.JSON_PROVIDER;
	},
	createHTMLFactory: function() {
		var df = new hrd.HtmlDialogFactory({
			title: this.settings.title,
			width: this.settings.width,
			popup: "{type:'form', prefix: 'attach-dialog'}"
		});

		var attachmentInfo = {
			droppable: this.settings.droppable,
			showAttachments: this.settings.showAttachments,
			attachmentsProperty: this.settings.attachmentProperty,
			provider: this.getJSONProvider(),
			method: this.settings.uploadMethod,
			dragMessage: this.settings.dragMessage,
			customizeAcceptables: this.settings.customizeAcceptables,
			customizeValidation: this.settings.customizeValidation,
			customizeFileObjectEnhancement: this.settings.customizeFileObjectEnhancement,
			closeWhenUploaded: this.settings.closeWhenUploaded,
			updateFormObject: this.settings.updateFormObject, // need to update formData with the new resource attachments info
			updateFormExtraField: this.settings.updateFormExtraField // need to update formData with the "id" fields in case of create
		};

		var attachmentOptions = {
			type: 'file',
			name: this.settings.property,
			info: attachmentInfo
		};

		if (this.settings.multiple == true) {
			attachmentOptions.multiple = 'multiple';
		}

		df.getFormFactory()
			.addFieldset(1)
			.addReadField('codice', { type: 'text', xlabel: '*** Codice ***', hidden: true })
			.addReadField('id', { type: 'text', xlabel: '*** Id ***', hidden: true })
			.addInputField('attachment', attachmentOptions);

		return df;
	},
	show: function(input) {
		input = input || {};
		let additionalFormData = this.getAdditionalFormData(input);
		let formData = {
			codice: input.codice,
			id: input.id
		};

		if (input[this.settings.attachmentProperty] != undefined) {
			formData[this.settings.attachmentProperty] = input[this.settings.attachmentProperty];
		}

		formData = $.extend(formData, additionalFormData);

		return this.openFormDialog($.extend(true, {}, formData), {
			okLabel: xlate('common.dialog.close.btn'),
			showCancelButton: false,
			destroyOnClose: true
		}).then((d, opt) => {
			// update parent form image
			this.parentFormInstance.toForm(d);
			return $.when(d, opt);
		});
	},
	attachmentFormData: function(field, formData, formInstance) {
		let additionalFormData = this.getAdditionalFormData(formData);
		let commonData = {
			codice: formData.codice,
			id: formData.id,
			fieldName: this.settings.property
		};
		return $.extend(commonData, additionalFormData);
	},
	getAdditionalFormData: function(formData) {
		return {};
	},
	attachmentEnhanceFileObject: function(file, formData, formInstance) {
		var iData = this.getInitialData();
		var extra = {};
		extra.deleteFileFn = () => {
			return dashboardInstance.invokeProvider(this.getJSONProvider(), this.settings.deleteMethod, {
				codice: formData.codice,
				id: formData.id,
				fieldName: this.settings.property
			});
		};
		extra.icon = `f-icon ${this.settings.basicIcon}`;
		return extra;
	},
	attachmentUploadCompleted: function(formData) {
		if (this.settings.updateFormExtraField != undefined) {
			// need to update this dialog formInstance with extra info returned back by upload invocation
			this.getFormInstance().toForm(formData);
		}

		if (this.settings.closeWhenUploaded) {
			// set autoclose on upload completed, forcing resolve so that underlying image is refreshed
			this.closeDialog(true);
		}
	}
});
